import { render, staticRenderFns } from "./timerplusmaxpresent.vue?vue&type=template&id=2e70f508&"
import script from "./timerplusmaxpresent.vue?vue&type=script&lang=js&"
export * from "./timerplusmaxpresent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports